import { Injectable, inject } from "@angular/core";
import {BehaviorSubject, catchError, map, Observable, of, tap} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {EnvLoader} from "../Environment/EnvLoader";
import {CookieService} from "ngx-cookie-service";
import {Router} from "@angular/router";

@Injectable({
    providedIn: 'root'
})
export class TokenService {
    private http = inject(HttpClient);
    private cookie = inject(CookieService);
    private router = inject(Router);

    private tokenBoGestionSubject = new BehaviorSubject<string>("");
    public tokenBoGestion$ = this.tokenBoGestionSubject.asObservable();

    private refreshTokenBoGestionSubject = new BehaviorSubject<string>("");
    public refreshTokenBoGestion$ = this.refreshTokenBoGestionSubject.asObservable();

    constructor() {
      this.populate();
    }

    setTokenBoGestion(token: string|null) {
        console.log(`[TokenService] New gestion token: ${token?.substring(token?.length - 10, token?.length)}`);

        this.tokenBoGestionSubject.next(token || "");
        if(token === null || token === ''){
            this.cookie.delete("orderTokenBoGestion", "/");
            return;
        }

        this.cookie.set("orderTokenBoGestion", token, 365, "/");
    }

    setRefreshTokenBoGestion(refreshToken: string|null) {
        console.log(`[TokenService] New gestion refresh token: ${refreshToken?.substring(refreshToken?.length - 10, refreshToken?.length)}`);

        this.refreshTokenBoGestionSubject.next(refreshToken || "");
        if(refreshToken === null || refreshToken === ''){
            this.cookie.delete("orderRefreshTokenBoGestion", "/");
            return;
        }

        this.cookie.set("orderRefreshTokenBoGestion", refreshToken, 365, "/");
    }

    getTokenBoGestion(): string {
        return this.tokenBoGestionSubject.getValue();
    }

    getRefreshTokenBoGestion(): string {
        return this.refreshTokenBoGestionSubject.getValue();
    }

    refreshToken(): Observable<{ token: string; refresh_token: string }> {
        const env = EnvLoader.load();

        return this.http.post<{ token: string; refresh_token: string }>(`${env.boGestionUrl}/token/refresh`, {
            refresh_token: this.getRefreshTokenBoGestion()
        }).pipe(
            tap(response => {
                this.setTokenBoGestion(response.token);
                this.setRefreshTokenBoGestion(response.refresh_token);
            }),
            catchError(err => {
                this.setRefreshTokenBoGestion(null);
                this.setTokenBoGestion(null);

                // Le refresh aussi a foiré, on doit afficher le login.
                window.location.reload();

                return of({token: "", refresh_token: ''});
            })
        );
    }

  private populate() {
    const token = this.cookie.get("orderTokenBoGestion");
    const refreshToken = this.cookie.get("orderRefreshTokenBoGestion");

    this.setTokenBoGestion(token);
    this.setRefreshTokenBoGestion(refreshToken);
  }
}
